module.exports = __webpack_public_path__ + "img/Old-Projects.b89603a3.jpg";